import { memo } from 'react';
import { useSession } from 'js/hooks/session';
import { useSessionRestore } from 'js/hooks/auth';
import { useGetForms } from 'js/hooks/useGetForms';
import { useReferrer } from 'js/hooks/useReferrer';
import { useNormalizeUrl } from 'js/hooks/language';
import { useAffiliate } from 'js/hooks/useAffiliate';
import { useTranslationsService } from 'js/hooks/i18n';
import { useFetchJackpots } from 'js/components/common/Jackpot';
import { useLiveGamesIntegration } from 'js/hooks/useLiveGamesIntegration';
import { useInitWidgets } from 'js/components/system/CommunicationWidgets/hooks';
import { useAgeVerificationPopup } from 'js/components/popups/AgeVerificationPopup';
import { useDataVerificationStatusPopup } from 'js/components/popups/DataVerificationStatusPopup';
import { useBiometricsHandler, useNativeCookieConsent, useNativeLogoutTrigger } from 'js/hooks/native';
import { useJumioVerifyStatusPopup, useJumioVerifyPopup } from 'js/components/popups/JumioVerifyPopup';
import { useLegacyModelSync, useBalanceAlert, useGetToastTimeoutValue, useOnAgeVerificationStatusChange } from 'js/hooks/user';

import * as hooks from './hooks';

export const AppPostInit = memo(() => {
    // at this point you should already be fetched app and user
    useSession();
    useReferrer();
    useAffiliate();
    useInitWidgets();
    useNormalizeUrl();
    useBalanceAlert();
    useFetchJackpots();
    useSessionRestore();
    useLegacyModelSync();
    hooks.usePromoCode();
    useJumioVerifyPopup();
    useBiometricsHandler();
    useNativeLogoutTrigger();
    useNativeCookieConsent();
    useTranslationsService();
    useAgeVerificationPopup();
    useGetToastTimeoutValue();
    hooks.useUnblockAccount();
    hooks.useThemeNameClass();
    useJumioVerifyStatusPopup();
    hooks.useResetFavoriteGames();
    hooks.useSetupCookiesGroups();
    hooks.useLegacyLoginHandler();
    hooks.useLegacyLogoutHandler();
    hooks.useLegacyRedirectHandler();
    hooks.useLegacyLanguageSelector();
    hooks.useLegacyGameLaunchHandler();
    hooks.useLegacyCoreNavigateListener();
    hooks.useLegacyQuickDepositListener();
    hooks.useLegacyBackButtonShowListener();
    hooks.useLegacyEmailVerificationTrigger();
    hooks.useDispatchPopupRendered();
    useLiveGamesIntegration();
    useGetForms();
    useDataVerificationStatusPopup();
    useOnAgeVerificationStatusChange();
    hooks.useSidebar();

    return null;
});
